//const BASE_URL = "http://localhost:3000";
// const BASE_URL = "https://api.udrivo.in"; // Replace with your actual base URL


const isProd = true; // Set to true for production, false for development
export const detailedReportsPaymentStatus = false; // Set to true for development, false for production


// export const BASE_URL = isProd
//   ? "https://stagging-udrivo-backend-production.up.railway.app"
//   : "http://localhost:9090";  

export const BASE_URL = isProd
  ? "https://web-api.udrivo.in"
  : "http://localhost:9090";  


// API Endpoints
export const API = {
  ADMIN: {
    BASE: `${BASE_URL}/api/admin`,
    LOGIN: `${BASE_URL}/api/admin/auth/login`,
    LOGOUT: `${BASE_URL}/api/admin/auth/logout`,
    REGISTER: `${BASE_URL}/api/admin/auth/register`,
    DASHBOARD_STATS: `${BASE_URL}/api/admin/dashboard/stats`,
    DASHBOARD_SUMMARY: `${BASE_URL}/api/admin/dashboard/summary`,
    DRIVER_ANALYTICS: `${BASE_URL}/api/driver-analytics/driver`,
    // Business Analytics Endpoints
    BUSINESS_ANALYTICS_DASHBOARD: `${BASE_URL}/api/business-analytics/dashboard`,
    BUSINESS_ANALYTICS_DRIVER_PROFILES: `${BASE_URL}/api/business-analytics/driver-profiles`,
    BUSINESS_ANALYTICS_KPIS: `${BASE_URL}/api/business-analytics/kpis`,
    ROLES_LIST: `${BASE_URL}/api/admin/roles/list`,
    ROLE_DETAILS: `${BASE_URL}/api/admin/roles/get`,
    CREATEROLEPERMISSION: `${BASE_URL}/api/admin/roles/create`,
    MODULES_LIST: `${BASE_URL}/api/admin/modules/list`,
    DRIVERS_LIST: `${BASE_URL}/api/admin/drivers/list`,
    DUPLICATE_PAN_LIST: `${BASE_URL}/api/admin/duplicate-pan/list`,
    DUPLICATE_PAN_CHECK: `${BASE_URL}/api/admin/duplicate-pan/check`,
    DUPLICATE_AADHAAR_LIST: `${BASE_URL}/api/admin/duplicate-aadhaar/list`,
    DUPLICATE_AADHAAR_CHECK: `${BASE_URL}/api/admin/duplicate-aadhaar/check`,
    DUPLICATE_DL_LIST: `${BASE_URL}/api/admin/duplicate-dl/list`,
    DUPLICATE_DL_CHECK: `${BASE_URL}/api/admin/duplicate-dl/check`,
    DRIVERS_BULK_ASSIGN: `${BASE_URL}/api/admin/drivers/bulk-assign`,
    DRIVER_DETAIL: `${BASE_URL}/api/admin/drivers/detail`,
    DRIVER_CREATE_START: `${BASE_URL}/api/admin/drivers/create-driver`,
    DRIVER_UPDATE_STATUS: `${BASE_URL}/api/admin/drivers/update-driver-status`,
    DRIVER_UPDATE_COMMISSION: `${BASE_URL}/api/admin/drivers/update-commission`,
    DRIVER_ACTIVE_STATUS: (id) => `${BASE_URL}/api/admin/drivers/active-status/${id}`,
    DRIVER_CALL_STATUS: `${BASE_URL}/api/admin/drivers/call-status`,
    DRIVERS_NEARBY: `${BASE_URL}/api/admin/drivers/nearby`,
    AVAILABLE_DRIVERS: `${BASE_URL}/api/admin/available-drivers`,
    AVAILABLE_DRIVERS_CELL: `${BASE_URL}/api/admin/available-drivers/cell`,
    USERS_LIST: `${BASE_URL}/api/admin/users/list`,
    USER_ACCOUNT_STATUS: (id) => `${BASE_URL}/api/admin/users/${id}/account-status`,
    USER_TEST_RECORD: (id) => `${BASE_URL}/api/admin/users/${id}/test-record`,
    EMPLOYEES_LIST: `${BASE_URL}/api/admin/employees/list`,
    ADMIN_LIST: `${BASE_URL}/api/admin/admins/list`,
    ADMINS_ADD: `${BASE_URL}/api/admin/admins/create`,
    EMPLOYEES_ADD: `${BASE_URL}/api/admin/employees/create`,
    EMPLOYEE_NEW_CREATE: `${BASE_URL}/api/admin/employees/new/create`,
    EMPLOYEE_NEW_UPDATE: (id) => `${BASE_URL}/api/admin/employees/new/${id}`,
    EMPLOYEE_DELETE: `${BASE_URL}/api/admin/employees`,
    ASSIGN_MODULE_ME: `${BASE_URL}/api/admin/employees/assign-module/me`,
    ASSIGN_MODULE_BY_EMPLOYEE: (id) => `${BASE_URL}/api/admin/employees/${id}/assign-module`,
    VEHICLE_TYPE_LIST: `${BASE_URL}/api/admin/vehicle/vehicle-types/list`,
    ISSUES_LIST: `${BASE_URL}/api/admin/issues/list`,
    ISSUES_ALL: `${BASE_URL}/api/admin/issues/all`,
    ISSUE_ASSIGN: `${BASE_URL}/api/admin/issues`,
    ISSUE_STATUS_UPDATE: `${BASE_URL}/api/admin/issues`,
    ISSUE_STATISTICS: `${BASE_URL}/api/admin/issues/statistics`,
    ISSUE_EMPLOYEES_AVAILABLE: `${BASE_URL}/api/admin/issues/employees/available`,
    ISSUE_MY_ASSIGNED: `${BASE_URL}/api/admin/issues/my-assigned`,
    ISSUE_DELETE: `${BASE_URL}/api/admin/issues`,
    // Rate Card Management Endpoints
    RATE_CARDS_ALL: `${BASE_URL}/api/admin/ratecards`,
    RATE_CARDS_CITIES_ALL: `${BASE_URL}/api/admin/ratecards/cities/all`,
    RATE_CARD_CITY_CREATE: `${BASE_URL}/api/admin/ratecards/city/create`,
    RATE_CARD_CITY_UPDATE: `${BASE_URL}/api/admin/ratecards/city`,
    RATE_CARD_CITY_DELETE: `${BASE_URL}/api/admin/ratecards/city`,
    RATE_CARD_CITY_GET: `${BASE_URL}/api/admin/ratecards/city`,
    RATE_CARD_COPY_MASTER: `${BASE_URL}/api/admin/ratecards/city/copy-master`,
    RATE_CARD_BULK_UPDATE: `${BASE_URL}/api/admin/ratecards/cities/bulk-update`,
    RATE_CARD_MASTER_UPDATE: `${BASE_URL}/api/admin/ratecards/master`,
    RATE_CARD_HISTORY: `${BASE_URL}/api/admin/ratecards/city`,
    // Settings Management Endpoints
    SETTINGS_ALL: `${BASE_URL}/api/admin/settings`,
    SETTINGS_LIST: `${BASE_URL}/api/admin/settings/list`,
    SETTINGS_GET: `${BASE_URL}/api/admin/settings`,
    SETTINGS_UPDATE: `${BASE_URL}/api/admin/settings/update`,
    SETTINGS_UPDATE_SINGLE: `${BASE_URL}/api/admin/settings`,
    SETTINGS_BULK_UPDATE: `${BASE_URL}/api/admin/settings/bulk-update`,
    SETTINGS_DELETE: `${BASE_URL}/api/admin/settings`,
    SETTINGS_RESET: `${BASE_URL}/api/admin/settings/reset`,
    DRIVER_LICENSEDETAILS: `${BASE_URL}/api/admin/drivers/dl-verification`,
    AADHAAR_DETAILS: `${BASE_URL}/api/admin/drivers/aadhaar-verification`,
    PAN_DETAILS: `${BASE_URL}/api/admin/drivers/pan-verification`,
    SUBMIT_PAN_CARD: `${BASE_URL}/api/admin/drivers/submit-pan-card`,
    BANK_DETAILS: `${BASE_URL}/api/admin/drivers/bank-verification`,
    DRIVING_CHOICES: `${BASE_URL}/api/admin/drivers/driving-choice`,
    VIDEO_DETAILS: `${BASE_URL}/api/admin/drivers/video-verification`,
    REQUESTOTP: `${BASE_URL}/api/v1/request-otp`,
    VERIFYOTP: `${BASE_URL}/api/v1/verify-otp`,
    RESENDOTP: `${BASE_URL}/api/v1/resend-otp`,
    USERDASHBOARD: `${BASE_URL}/api/v1/driver/profile`,
    GET_ADMIN_PROFILE: `${BASE_URL}/api/admin/auth/profile`,
    CHANGE_PASSWORD: `${BASE_URL}/api/admin/auth/change-password`,
    SAVE_DRIVING_CHOICES: `${BASE_URL}/api/v1/save-driving-choices`,
    // Ride Management Endpoints
    RIDE_GET_OTPS: `${BASE_URL}/api/v2/ride/get-otps-by-phone`,
    RIDES_LIST: `${BASE_URL}/api/admin/rides`,
    RIDES_TRIPS_METRICS: `${BASE_URL}/api/admin/rides/trips-metrics`,
    DRIVERS_METRICS: `${BASE_URL}/api/admin/drivers/metrics`,
    DRIVER_EMPLOYEE_STATS: `${BASE_URL}/api/admin/drivers/employee-stats`,
    RIDE_DETAIL: `${BASE_URL}/api/admin/rides`,
    RIDE_UPDATE_STATUS: `${BASE_URL}/api/admin/rides`,
    RIDE_MOBILE_NUMBER_SHARED: `${BASE_URL}/api/admin/rides`,
    RIDES_STATISTICS: `${BASE_URL}/api/admin/rides/statistics`,
    RIDES_STATUS_BREAKDOWN: `${BASE_URL}/api/admin/rides/status-breakdown`,
    RIDES_EMPLOYEE_STATS: `${BASE_URL}/api/admin/rides/employee-stats`,
    RIDES_RECENT_ACTIVITY: `${BASE_URL}/api/admin/rides/recent-activity`,
    RIDES_EXPORT: `${BASE_URL}/api/admin/rides/export`,
    SAVE_ADMIN_DRIVING_CHOICES: `${BASE_URL}/api/v1/admin-save-driving-choices`,
    RIDES_BULK_ASSIGN: `${BASE_URL}/api/admin/rides/bulk-assign`,
    CANCELLATION_SUSPENDED_CUSTOMERS: `${BASE_URL}/api/admin/cancellation-suspended/customers`,
    CANCELLATION_SUSPENDED_CUSTOMER_CANCELLATIONS: (userId) =>
      `${BASE_URL}/api/admin/cancellation-suspended/customers/${userId}/cancellations`,
    CANCELLATION_SUSPENDED_DRIVERS: `${BASE_URL}/api/admin/cancellation-suspended/drivers`,
    CANCELLATION_SUSPENDED_DRIVER_CANCELLATIONS: (driverId) =>
      `${BASE_URL}/api/admin/cancellation-suspended/drivers/${driverId}/cancellations`,
    NUMBER_SHARING_SUSPENDED_CUSTOMERS: `${BASE_URL}/api/admin/number-sharing-suspended/customers`,
    NUMBER_SHARING_SUSPENDED_CUSTOMER_NOTES: (userId) =>
      `${BASE_URL}/api/admin/number-sharing-suspended/customers/${userId}/notes`,
    NUMBER_SHARING_SUSPENDED_CUSTOMER_STATUS: (userId) =>
      `${BASE_URL}/api/admin/number-sharing-suspended/customers/${userId}/status`,
    NUMBER_SHARING_SUSPENDED_CUSTOMER_CALLER_HISTORY: (userId) =>
      `${BASE_URL}/api/admin/number-sharing-suspended/customers/${userId}/caller-history`,
    NUMBER_SHARING_SUSPENDED_DRIVERS: `${BASE_URL}/api/admin/number-sharing-suspended/drivers`,
    NUMBER_SHARING_SUSPENDED_DRIVER_NOTES: (driverId) =>
      `${BASE_URL}/api/admin/number-sharing-suspended/drivers/${driverId}/notes`,
    NUMBER_SHARING_SUSPENDED_DRIVER_STATUS: (driverId) =>
      `${BASE_URL}/api/admin/number-sharing-suspended/drivers/${driverId}/status`,
    NUMBER_SHARING_SUSPENDED_DRIVER_CALLER_HISTORY: (driverId) =>
      `${BASE_URL}/api/admin/number-sharing-suspended/drivers/${driverId}/caller-history`,
    ACTIVITY_LOGS: `${BASE_URL}/api/admin/activity-logs`,
    DRIVER_ACTIVITY_LOGS: (driverId) =>
      `${BASE_URL}/api/admin/activity-logs/driver/${driverId}`,
    RIDE_ACTIVITY_LOGS: (rideId) =>
      `${BASE_URL}/api/admin/activity-logs/ride/${rideId}`,
    RIDE_TEST_UPDATE_STARTED_AT: `${BASE_URL}/api/v2/ride/test/update-started-at`,
    DOCUMENT_UPLOAD: `${BASE_URL}/api/v1/documents/upload`,
    ADMINDOCUMENT_UPLOAD: `${BASE_URL}/api/v1/admindocuments/upload`,
    AADHAAR_GENERATE_KYC: `${BASE_URL}/api/v1/aadhar/generate-okyc`,
    AADHAAR_VERIFY_KYC: `${BASE_URL}/api/v1/aadhar/verify-okyc`,
    VERIFY_DRIVING_LICENSE: `${BASE_URL}/api/v1/driving-license/verify`,
    ADMIN_VERIFY_DRIVING_LICENSE: `${BASE_URL}/api/v1/driving-license/admin-verify`,
    ADMIN_VERIFY_AADHAAR: `${BASE_URL}/api/v1/aadhar/admin-generate-okyc`,
    ADMIN_VERIFY_BANK: `${BASE_URL}/api/v1/bank-account/admin-verify`,
    VERIFY_PAN_CARD: `${BASE_URL}/api/v1/pan/verify`,
    ADMIN_VERIFY_PAN_CARD: `${BASE_URL}/api/v1/pan/admin-verify`,
    VERIFY_BANK_ACCOUNT: `${BASE_URL}/api/v1//bank-account/verify`,
    SAVE_DRIVING_VIDEOS: `${BASE_URL}/api/v1/save-driving-videos`,
    VIDEO_UPLOAD: `${BASE_URL}/api/v1/videos/upload`,
    VIDEO_ADMIN_UPLOAD: `${BASE_URL}/api/v1/videos/admin-upload`,
    ADMIN_SAVE_DRIVING_VIDEOS: `${BASE_URL}/api/v1/admin-save-driving-videos`,
    UPDATE_DRIVER: `${BASE_URL}/api/admin/drivers/updateprofile`,
    SEND_OTP_DRIVER: `${BASE_URL}/api/admin/drivers/send-otp`,
    GET_SENIORS: `${BASE_URL}/api/admin/employees/get-seniors`,
    GET_JUNIORS: `${BASE_URL}/api/admin/employees/get-juniors`,
    GET_NOTIFICATION: `${BASE_URL}/api/admin/employees/notifications`,
    MARK_NOTIFICATION_READ: `${BASE_URL}/api/admin/employees/notification/mark-as-read`,
    EMPLOYEE_PROFILE: `${BASE_URL}/api/admin/employees/profile`,
    // Subscription Management Endpoints
    SUBSCRIPTION_ANALYTICS: `${BASE_URL}/api/admin/subscriptions/analytics`,
    SUBSCRIPTION_LIST: `${BASE_URL}/api/admin/subscriptions`,
    SUBSCRIPTION_CREATE: `${BASE_URL}/api/admin/subscriptions/create`,
    SUBSCRIPTION_UPDATE: `${BASE_URL}/api/admin/subscriptions/update`,
    SUBSCRIPTION_DELETE: `${BASE_URL}/api/admin/subscriptions/delete`,
    SUBSCRIPTION_DETAIL: `${BASE_URL}/api/admin/subscriptions`,
    SUBSCRIPTION_BULK_UPDATE: `${BASE_URL}/api/admin/subscriptions/bulk-update`,
    SUBSCRIPTION_BULK_DELETE: `${BASE_URL}/api/admin/subscriptions/bulk-delete`,
    SUBSCRIPTION_EXPORT: `${BASE_URL}/api/admin/subscriptions/export`,
    SUBSCRIPTION_UNSUBSCRIBED_DRIVERS: `${BASE_URL}/api/admin/subscriptions/drivers/unsubscribed`,
    SUBSCRIPTION_BULK_MESSAGE: `${BASE_URL}/api/admin/subscriptions/bulk-message`,
    SUBSCRIPTION_ACTIVATE: `${BASE_URL}/api/admin/subscriptions`,
    SUBSCRIPTION_EXPIRE: `${BASE_URL}/api/admin/subscriptions`,
    SUBSCRIPTION_BULK_EXPIRE: `${BASE_URL}/api/admin/subscriptions/bulk/expire`,
    SUBSCRIPTION_REMIND: `${BASE_URL}/api/admin/subscriptions`,
    // Bulk Driver Upload
    DRIVER_BULK_UPLOAD: `${BASE_URL}/api/admin/drivers/bulk-upload`,
    // Auto Subscription Extension
    SUBSCRIPTION_AUTO_EXTEND: `${BASE_URL}/api/admin/subscriptions/auto-extend`,

    // Business Analytics - Location-Based Driver Analytics
    ANALYTICS_DRIVERS_LOCATION_WISE: `${BASE_URL}/api/admin/analytics/drivers/location-wise`,
    ANALYTICS_DRIVERS_BY_LOCATION: `${BASE_URL}/api/admin/analytics/drivers/by-location`,

    // Business Analytics - Customer Analytics
    ANALYTICS_CUSTOMERS_CITY_WISE: `${BASE_URL}/api/admin/analytics/customers/city-wise`,
    ANALYTICS_CUSTOMERS_REAL_TIME: `${BASE_URL}/api/admin/analytics/customers/real-time`,

    // Business Analytics - Comprehensive Analytics
    ANALYTICS_COMPREHENSIVE: `${BASE_URL}/api/admin/analytics/comprehensive`,

    // Business Analytics - Ride Analytics
    ANALYTICS_RIDES_CITY_WISE: `${BASE_URL}/api/admin/analytics/rides/city-wise`,

    // Commission Report Endpoints
    COMMISSION_REPORT: `${BASE_URL}/api/admin/commissions/report`,
    COMMISSION_REPORT_DETAILED: `${BASE_URL}/api/admin/commissions/report/detailed`,
    COMMISSION_REVENUE_METRICS: `${BASE_URL}/api/admin/commissions/revenue-metrics`,
    COMMISSION_UPDATE_STATUS: `${BASE_URL}/api/admin/commissions`,
    COMMISSION_PHONEPE_SETTLEMENT_UPLOAD: `${BASE_URL}/api/admin/commissions/phonepe-settlement/upload`,
    COMMISSION_PHONEPE_SETTLEMENT_LIST: `${BASE_URL}/api/admin/commissions/phonepe-settlement`,
    COMMISSION_TAX_INVOICE_SUMMARY: `${BASE_URL}/api/admin/commissions/tax-invoice/summary`,
    COMMISSION_TAX_INVOICE_STATEWISE: `${BASE_URL}/api/admin/commissions/tax-invoice/statewise`,

    CALL_BLASTING_TRIGGER: `${BASE_URL}/api/admin/call-blasting/trigger`,
    CALL_BLASTING_BATCHES: `${BASE_URL}/api/admin/call-blasting/batches`,
    CALL_BLASTING_BATCH_PREVIEW: `${BASE_URL}/api/admin/call-blasting/batches/preview`,
    CALL_BLASTING_BATCH_LOGS: `${BASE_URL}/api/admin/call-blasting/batch-logs`,
    CALL_BLASTING_BATCH_LOGS_SKIPPED: `${BASE_URL}/api/admin/call-blasting/batch-logs/skipped`,
    CALL_BLASTING_SCHEDULE: `${BASE_URL}/api/admin/call-blasting/schedule`,
    CALL_BLASTING_SCHEDULE_STOP: `${BASE_URL}/api/admin/call-blasting/schedule/stop`,
    CALL_BLASTING_SCHEDULE_RUN_STATUS: `${BASE_URL}/api/admin/call-blasting/schedule/run-status`,
    CALL_BLASTING_FLOW_TRIGGER: `${BASE_URL}/api/admin/call-blasting/flows/trigger`,
    CALL_BLASTING_FLOW_BATCHES: `${BASE_URL}/api/admin/call-blasting/flows/batches`,
    CALL_BLASTING_FLOW_BATCH_PREVIEW: `${BASE_URL}/api/admin/call-blasting/flows/batches/preview`,
    CALL_BLASTING_FLOW_BATCH_LOGS: `${BASE_URL}/api/admin/call-blasting/flows/batch-logs`,
    CALL_BLASTING_FLOW_BATCH_LOGS_SKIPPED: `${BASE_URL}/api/admin/call-blasting/flows/batch-logs/skipped`,
    CALL_BLASTING_FLOW_SCHEDULE: `${BASE_URL}/api/admin/call-blasting/flows/schedule`,
    CALL_BLASTING_FLOW_SCHEDULE_STOP: `${BASE_URL}/api/admin/call-blasting/flows/schedule/stop`,
    CALL_BLASTING_FLOW_SCHEDULE_RUN_STATUS: `${BASE_URL}/api/admin/call-blasting/flows/schedule/run-status`,
    CALL_BLASTING_LOCATION_TRIGGER: `${BASE_URL}/api/admin/call-blasting/location/trigger`,
    CALL_BLASTING_LOCATION_BATCHES: `${BASE_URL}/api/admin/call-blasting/location/batches`,
    CALL_BLASTING_LOCATION_BATCH_PREVIEW: `${BASE_URL}/api/admin/call-blasting/location/batches/preview`,
    CALL_BLASTING_LOCATION_BATCH_LOGS: `${BASE_URL}/api/admin/call-blasting/location/batch-logs`,
    CALL_BLASTING_LOCATION_BATCH_LOGS_SKIPPED: `${BASE_URL}/api/admin/call-blasting/location/batch-logs/skipped`,
    CALL_BLASTING_LOCATION_SCHEDULE: `${BASE_URL}/api/admin/call-blasting/location/schedule`,
    CALL_BLASTING_LOCATION_SCHEDULE_STOP: `${BASE_URL}/api/admin/call-blasting/location/schedule/stop`,
    CALL_BLASTING_LOCATION_SCHEDULE_RUN_STATUS: `${BASE_URL}/api/admin/call-blasting/location/schedule/run-status`,
    CALL_BLASTING_JOINING_FEE_PENDING_TRIGGER: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/trigger`,
    CALL_BLASTING_JOINING_FEE_PENDING_BATCHES: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/batches`,
    CALL_BLASTING_JOINING_FEE_PENDING_BATCH_PREVIEW: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/batches/preview`,
    CALL_BLASTING_JOINING_FEE_PENDING_BATCH_LOGS: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/batch-logs`,
    CALL_BLASTING_JOINING_FEE_PENDING_BATCH_LOGS_SKIPPED: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/batch-logs/skipped`,
    CALL_BLASTING_JOINING_FEE_PENDING_SCHEDULE: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/schedule`,
    CALL_BLASTING_JOINING_FEE_PENDING_SCHEDULE_STOP: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/schedule/stop`,
    CALL_BLASTING_JOINING_FEE_PENDING_SCHEDULE_RUN_STATUS: `${BASE_URL}/api/admin/call-blasting/joining-fee-pending/schedule/run-status`,
    CALL_BLASTING_USERS_REGISTERED_TRIGGER: `${BASE_URL}/api/admin/call-blasting/users-registered/trigger`,
    CALL_BLASTING_USERS_REGISTERED_BATCHES: `${BASE_URL}/api/admin/call-blasting/users-registered/batches`,
    CALL_BLASTING_USERS_REGISTERED_BATCH_PREVIEW: `${BASE_URL}/api/admin/call-blasting/users-registered/batches/preview`,
    CALL_BLASTING_USERS_REGISTERED_BATCH_LOGS: `${BASE_URL}/api/admin/call-blasting/users-registered/batch-logs`,
    CALL_BLASTING_USERS_REGISTERED_BATCH_LOGS_SKIPPED: `${BASE_URL}/api/admin/call-blasting/users-registered/batch-logs/skipped`,
    CALL_BLASTING_USERS_REGISTERED_SCHEDULE: `${BASE_URL}/api/admin/call-blasting/users-registered/schedule`,
    CALL_BLASTING_USERS_REGISTERED_SCHEDULE_STOP: `${BASE_URL}/api/admin/call-blasting/users-registered/schedule/stop`,
    CALL_BLASTING_USERS_REGISTERED_SCHEDULE_RUN_STATUS: `${BASE_URL}/api/admin/call-blasting/users-registered/schedule/run-status`,
    RIDE_DECLINE_REASONS: (rideId) =>
      `${BASE_URL}/api/admin/rides/${rideId}/decline-reasons`,
    JOINING_FEE_CONFIG: `${BASE_URL}/api/admin/joining-fee/config`,
    JOINING_FEE_PAYMENTS: `${BASE_URL}/api/admin/joining-fee/payments`,
  },
  // User Management & Analytics Endpoints
  USER: {
    USER_DETAILS_ALL: `${BASE_URL}/api/user-details/all`,
    USER_DETAILS: `${BASE_URL}/api/user-details/user`,
    USER_STATUS_UPDATE: `${BASE_URL}/api/user-details/user`,
    USER_STATISTICS: `${BASE_URL}/api/user-details/statistics`,
    USER_ANALYTICS_ALL: `${BASE_URL}/api/user-analytics/all`,
    USER_ANALYTICS: `${BASE_URL}/api/user-analytics/user`,
    USER_LEADERBOARD: `${BASE_URL}/api/user-analytics/leaderboard`,
  },

  // Dashboard Analytics Endpoints
  DASHBOARD: {
    MAIN_ANALYTICS: `${BASE_URL}/api/admin/dashboard/main-analytics`,
    DRIVER_ANALYTICS: `${BASE_URL}/api/driver-analytics/driver`,
    USER_ANALYTICS: `${BASE_URL}/api/user-analytics/user`,
    GRAPH_DATA: `${BASE_URL}/api/admin/dashboard/graph-data`,
    REAL_TIME_STATS: `${BASE_URL}/api/admin/dashboard/real-time-stats`,
  },
};

export default API;
